import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import AddCarrierForm from '@components/bedrock/pages/agents/openbook/AddCarrierForm';
import { AddCarrierFormVariants } from './AddCarrierForm/enums';

const AddCarrierModal = ({ isOpen, onClose, initialCarrier }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay bg="#00000039" backdropFilter="blur(2px)" />
    <ModalContent width="fit-content">
      <AddCarrierForm
        onComplete={onClose}
        initialCarrier={initialCarrier}
        variant={AddCarrierFormVariants.AddCarrier}
      />
    </ModalContent>
  </Modal>
);

export default AddCarrierModal;
